import { render, staticRenderFns } from "./AppConfirmDialog.vue?vue&type=template&id=9c197960&scoped=true"
import script from "./AppConfirmDialog.vue?vue&type=script&lang=js"
export * from "./AppConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./AppConfirmDialog.vue?vue&type=style&index=0&id=9c197960&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c197960",
  null
  
)

export default component.exports